export default __webpack_public_path__ + "static/N0060-6ff9b7f4ea77f980674a1f3d2e3fe179.png";